export enum ErrorState {
    FailedToSend = 1, // Set to 1 to stop boolean errors if set to 0
    OptedOut,
    InvalidNumber
}
